import React, { useState } from 'react';
import Table from 'react-bootstrap/Table'; // If using React Bootstrap
import ViewModal from './ViewModal';
import { useDispatch } from 'react-redux'; // Assuming you're using redux to dispatch actions
import { deleteEvent } from '../../../store/actions/eventActions'; // Assuming you're using redux to dispatch actions

const EventTable = ({ events }) => { // Accept deleteEventAction as a prop
  let slno = 1;

  // View events modal   
  const [checkedData, setCheckedData] = useState('');
  const [viewModal, setViewModal] = useState(false);
  const [loading, setLoading] = useState(false); // For handling loading state

  // Open the modal
  const showView = () => setViewModal(true);
  // Close the modal
  const closeView = () => setViewModal(false);

  const dispatch = useDispatch(); // If using redux for state management

  // Select event for viewing
  const selectEvent = (event_id) => {
    const selectedEvent = events.data.filter(event => event.event_id === event_id);
    if (selectedEvent.length > 0) {
      setCheckedData(selectedEvent[0]);
      showView();
    }
  };

  // Handle delete event
  const deleteEventFunction = async (event_id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this event?');
    if (confirmDelete) {
      setLoading(true);
      try {
        dispatch(deleteEvent(event_id)); // Assuming this dispatches the delete action in redux
        setLoading(false);
      } catch (error) {
        console.error('Error deleting event:', error);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Table striped bordered hover> {/* Replace with <table> if not using Bootstrap */}
        <thead>
          <tr>
            <th>Sl. No.</th>
            <th>Event</th>
            <th>Date</th>
            <th>Time</th>
            <th>Location</th>
            <th>Organizer</th>
            <th>Type</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {events && events.data && events.data.map((event) => (
            <tr key={event.event_id}>
              <td>{slno++}</td>
              <td>{event.event_name}</td>
              <td>{event.event_date}</td>
              <td>{event.event_time}</td>
              <td>{event.event_location}</td>
              <td>{event.organizer_name}</td>
              <td>{event.event_type}</td>
              <td>{event.event_status}</td>
              <td>
                <div className="d-flex">
                  <div className="icon-box icon-box-sm bg-light me-2" onClick={() => selectEvent(event.event_id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M120-120v-320h80v184l504-504H520v-80h320v320h-80v-184L256-200h184v80H120Z"/></svg>
                  </div>
                  <div className="icon-box icon-box-sm bg-light me-2">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M200-200h56l345-345-56-56-345 345v56Zm572-403L602-771l56-56q23-23 56.5-23t56.5 23l56 56q23 23 24 55.5T829-660l-57 57Zm-58 59L290-120H120v-170l424-424 170 170Zm-141-29-28-28 56 56-28-28Z"/></svg>
                  </div>
                  <div className="icon-box icon-box-sm bg-light" onClick={() => deleteEventFunction(event.event_id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M600-240v-80h160v80H600Zm0-320v-80h280v80H600Zm0 160v-80h240v80H600ZM120-640H80v-80h160v-60h160v60h160v80h-40v360q0 33-23.5 56.5T440-200H200q-33 0-56.5-23.5T120-280v-360Zm80 0v360h240v-360H200Zm0 0v360-360Z"/></svg>
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Show view modal */}
      <ViewModal data={checkedData} closeView={closeView} viewModal={viewModal} />

      {loading && <p>Deleting event...</p>}
    </>
  );
};

export default EventTable;
